import React, { useState } from 'react'
import Close from '../assets/assets/VectorClose.svg'
import WeekdaySelector from './weekDaySelect'
import Recaptcha from 'react-google-recaptcha'
import { Alert, Col, Row } from 'react-bootstrap'
import logo1 from '../assets/reading-side.svg'

function InputForm({ ShowForm, ActionName, error, loader, formSubmitHandler }) {
  const [captchaSucces, setCaptchaSuccess] = useState(false)
  const [formData, setFormData] = useState({
    user_name: '',
    user_email: '',
    job_type: '',
    job_type_other: '',
    teaching_mode: '',
    availability: [],
    time_slot: [],
    expertise: '',
    expertise_other: '',
    experience: '',
    mobile_no: '',
    emirates: '',
    uploaded_cv: '',
    profile_pic: '',
  })
  const [jobTypeOther, setJobTypeOther] = useState(false)
  const [expertise, setExpertise] = useState(false)
  const [fileName, setFileName] = useState('')
  const [profileFileName, setProfileFileName] = useState('')
  const [jobTypeOptions] = useState([
    'Banker',
    'Business Personnel',
    'Designer',
    'E-commerce',
    'Education',
    'Engineer',
    'Engineering and Construction',
    'Entertainment and Media',
    'Environmental Conservation',
    'Finance',
    'Freelancer',
    'Healthcare',
    'Hospitality and Tourism',
    'Sustainability & Renewable Energy',
    'Technology',
    'Other',
  ])
  const [cities] = useState([
    'Abu Dhabi',
    'Dubai',
    'Sharjah',
    'Umm Al Quwain',
    'Ajman',
    'Ras al Khaimah',
    'Fujairah',
    'London',
  ])

  const inputHandler = (e) => {
    // console.log(e.target.name, e.target.value)
    if (e.target.name === 'job_type' && e.target.value === 'Other') {
      setJobTypeOther(true)
    }
    if (e.target.name === 'job_type' && e.target.value !== 'Other') {
      setJobTypeOther(false)
    }
    if (e.target.name === 'expertise' && e.target.value === 'Other') {
      // console.log('====')
      setExpertise(true)
    }
    if (e.target.name === 'expertise' && e.target.value !== 'Other') {
      setExpertise(false)
    }
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }))
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    // Validate hCaptcha response
    if (captchaSucces) {
      formSubmitHandler(formData)
    } else {
      alert('All fields are required')
    }
  }

  // The New Obj That We want to add (id is the > max id you can get it from db  )

  function handleFileInputChange(event) {
    if (event.target.files) {
      setFileName(event.target.files[0].name)
      setFormData((prev) => ({
        ...prev,
        uploaded_cv: event.target.files[0],
      }))
    }
  }
  function profilePicInputHandler(event) {
    if (event.target.files) {
      setProfileFileName(event.target.files[0].name)
      setFormData((prev) => ({
        ...prev,
        profile_pic: event.target.files[0],
      }))
    }
  }

  const succesHandler = () => {
    setCaptchaSuccess(true)
  }

  return (
    <div className='InputForm animate-bottom'>
      <div className='container'>
        <div className='close-icon'>
          <img
            src={Close}
            alt='closeButton'
            onClick={() => ShowForm(false)}
            className='cursor-pointer'
          ></img>
        </div>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <h2 style={{ color: 'green', fontWeight: 'bold', fontSize: '34px' }}>
            {ActionName}
          </h2>
          <p
            className='bottomNoteText'
            style={{ color: '#3d995b', fontWeight: 'bold' }}
          >
            Register as a guest lecturer with your industry expertise to teach
            in the higher education sector
          </p>
        </div>
        <div className='inner-container'>
          <div className='input-form-left-container' style={{ padding: 70 }}>
            <img src={logo1} className='img-fluid' alt='logo' />
          </div>
          <div className='input-form-right-container'>
            <form action='' onSubmit={handleSubmit} className=''>
              {error && (
                <Alert variant='danger' style={{ display: 'flex' }}>
                  {error}
                </Alert>
              )}
              <Row>
                <Col md={6}>
                  <div className='custom-input-group'>
                    <label>Name *</label>
                    <input
                      type='text'
                      placeholder='John Doe'
                      name='user_name'
                      onChange={inputHandler}
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className='custom-input-group'>
                    <label>Email *</label>
                    <input
                      type='email'
                      placeholder='example@xyz.com'
                      name='user_email'
                      onChange={inputHandler}
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className='custom-input-group'>
                    <label>Mobile *</label>
                    <input
                      type='text'
                      placeholder='9999999999'
                      name='mobile_no'
                      onChange={inputHandler}
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className='custom-input-group'>
                    <label>Job Type *</label>
                    <select
                      name='job_type'
                      style={{ padding: '0.6rem' }}
                      onChange={inputHandler}
                    >
                      <option val=''>- Select Job Type -</option>
                      {jobTypeOptions.map((value, key) => (
                        <option key={key} value={value}>
                          {value}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
                {jobTypeOther && (
                  <Col md={6}>
                    <div className='custom-input-group'>
                      <label>Please Specify *</label>

                      <input
                        type='text'
                        placeholder='Manager'
                        name='job_type_other'
                        onChange={inputHandler}
                      />
                    </div>
                  </Col>
                )}
                <Col md={6}>
                  <div className='custom-input-group'>
                    <label>Teaching Mode *</label>

                    <select name='teaching_mode' onChange={inputHandler}>
                      <option value=''>- Select Mode -</option>
                      {['Face-To-Face', 'Online'].map((mode) => (
                        <option key={mode} value={mode}>
                          {mode}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
                <Col md={6}>
                  <div className='custom-input-group'>
                    <label>Choose Availability *</label>
                    <WeekdaySelector
                      name='availability'
                      title='Choose Availability'
                      onChange={inputHandler}
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className='custom-input-group'>
                    <label>Choose Time Slot *</label>
                    <WeekdaySelector
                      name='time_slot'
                      title='Choose Time Slot'
                      Values={['9AM-12PM', '12PM-3PM', '3PM-6PM', '6PM-9PM']}
                      onChange={inputHandler}
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className='custom-input-group'>
                    <label>Select Expertise *</label>
                    <select name='expertise' onChange={inputHandler}>
                      <option val=''>- Select Expertise -</option>
                      {['IT', 'Business', 'Other'].map((mode) => (
                        <option key={mode} value={mode}>
                          {mode}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
                {expertise && (
                  <Col md={6}>
                    <div className='custom-input-group'>
                      <label>Please Specify *</label>
                      <input
                        type='text'
                        placeholder='Marketing'
                        name='expertise_other'
                        onChange={inputHandler}
                      />
                    </div>
                  </Col>
                )}
                <Col md={6}>
                  <div className='custom-input-group'>
                    <label>Experience *</label>
                    <input
                      type='text'
                      placeholder='2 Years'
                      name='experience'
                      onChange={inputHandler}
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className='custom-input-group'>
                    <label>Select Emirate/City *</label>
                    <select name='emirates' onChange={inputHandler}>
                      <option val=''>- Select Emirate/City -</option>
                      {cities.map((mode) => (
                        <option key={mode} value={mode}>
                          {mode}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
                <Col md={6}>
                  <div className='custom-input-group'>
                    <label>Upload Your Resume *</label>
                    <div
                      className='input'
                      onClick={() => {
                        document.getElementById('uploadCV').click()
                      }}
                      style={{
                        wordWrap: 'break-word',
                        wordBreak: 'break-word',
                      }}
                    >
                      {!fileName ? 'Upload CV' : fileName}
                    </div>
                    <input
                      id='uploadCV'
                      style={{ display: 'none' }}
                      type='file'
                      name='uploaded_cv'
                      onChange={handleFileInputChange}
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className='custom-input-group'>
                    <label>Upload Profile Picture *</label>
                    <div
                      className='input'
                      onClick={() => {
                        document.getElementById('profilePIC').click()
                      }}
                      style={{
                        wordWrap: 'break-word',
                        wordBreak: 'break-word',
                      }}
                    >
                      {!profileFileName ? 'Profile Picture' : profileFileName}
                    </div>
                    <input
                      id='profilePIC'
                      style={{ display: 'none' }}
                      type='file'
                      name='profile_pic'
                      onChange={profilePicInputHandler}
                    />
                  </div>
                </Col>
              </Row>

              <div className='captchaBox'>
                <Recaptcha
                  sitekey='6Lc34ycmAAAAAE4XuOczDOAUWWNGIfOecd6WnJQd'
                  onChange={succesHandler}
                />
              </div>

              <div className='d-flex'>
                {loader && (
                  <button
                    className='RegButton mt-2 disabled'
                    type='submit'
                    onClick={(e) => {
                      e.preventDefault()
                    }}
                  >
                    Please Wait
                  </button>
                )}

                {!loader && (
                  <button className='RegButton mt-2' type='submit'>
                    Submit
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}
export default InputForm
